(function ($) {

    $(function () {
        $(".show-marketing-desc").click(function (e) {
            $(".marketing-desc").delay(400).show();
        });

        $(".hide-marketing-desc").click(function (e) {
            $(".marketing-desc").hide();
        });

        $(".NLform").each(function () {
            updateChannelFields($(this));
        });

        $(".signup-contact-method").change(function (e) {
            var form = $(this).closest("form");
            clearValidationErrors(form);
            updateChannelFields(form);
        });

        // newsletter validation
        $("#btnSubscribe").click(function (e) {
            e.preventDefault();
            var _this = $(this);
            var _form = _this.closest("form");

            trySubscribe(_form);
        });

    });

    var trySubscribe = function (form) {
        $(".submit-loader-wrap").show();
        $('#SignupCountry').removeAttr("disabled");
        $('#btnSubscribe').prop('disabled', true);
        $.ajax({
            type: "POST",
            url: $(form).attr("action"),
            data: form.serialize(),
            success: function (data, status, xhr) {
                $(".submit-loader-wrap").hide();

                var isSuccessful = (data["success"]);
                if (isSuccessful) {
                    $("#NLmain").hide();
                    var customSuccessMessage = form.closest("[data-success-message]").data("success-message");
                    $(".successMessage").prepend(customSuccessMessage || getSuccessMessage(data)).addClass("show");

                    if (data["inboxLink"]) {
                        $(".inboxLink").html("<a href='" + data["inboxLink"] + "'>Check your inbox.</a>");
                    }
                }
                else {
                    var errors = data["errors"];
                    displayValidationErrors(errors);
                }
                $('#btnSubscribe').prop('disabled', false);
            },
            error: function (xhr, status, err) {
                $(".submit-loader-wrap").hide();

                $("#NLmain").hide();
                $(".successMessage").text("There's been an error while sending your information. Please try again later.").addClass("show error");
                $('#btnSubscribe').prop('disabled', false);
            }
        });
    };

    function updateChannelFields(form) {
        var selectedContactMethod = form.find("input[name='SignupContactMethod']:checked").val() || "Email";
        var emailSelected = selectedContactMethod === "Email" || selectedContactMethod === "EmailAndSms";
        var smsSelected = selectedContactMethod === "Sms" || selectedContactMethod === "EmailAndSms";
        var smsField = form.find("[data-sms-signup-field]");

        if (!smsField.length) {
            return;
        }

        var emailField = form.find("[data-email-signup-field]");
        var emailInput = form.find("#SignupEmail");
        var smsDiallingCodeInput = form.find("#SignupMobileDiallingCode");
        var smsInput = form.find("#SignupMobileNumber");

        emailField.toggle(emailSelected);
        emailInput.prop("disabled", !emailSelected);
        form.find(".email-required-indicator").toggle(emailSelected);

        smsField.toggle(smsSelected);
        smsDiallingCodeInput.prop("disabled", !smsSelected);
        smsInput.prop("disabled", !smsSelected);

    }

    var getSuccessMessage = function (data) {
        if (data["emailSubscribed"] && data["smsSubscribed"]) {
            return "<span class='message-copy'><strong>Thanks. You’re on the list.</strong><br>We’ve sent an email confirmation and you will now receive text updates. You can update your preferences at any time. Reply STOP to end SMS, HELP for help.</span> ";
        }

        if (data["smsSubscribed"] && !data["emailSubscribed"]) {
            return "<span class='message-copy'><strong>SMS confirmed</strong><br>You will now receive text updates. Reply STOP to end, HELP for help.</span> ";
        }

        var message = "<span class='message-copy'><strong>Thanks. You’re on the list.</strong>";
        if (data["emailSubscribed"]) {
            message += "<br>We’ve sent a confirmation. You can update your preferences at any time.";
        }
        if (data["smsSubscribed"]) {
            message += "<br><strong>SMS confirmed</strong><br>You will now receive text updates. Reply STOP to end, HELP for help.";
        }

        return message + "</span> ";
    };

    var displayValidationErrors = function (modelStateErrors) {
        clearValidationErrors($("#NLsignup"));
        for (var i = 0; i < modelStateErrors.length; i++) {
            $("span[data-valmsg-for='" + modelStateErrors[i].key + "']").text(modelStateErrors[i].errors[0]).addClass("show");
            $("#" + modelStateErrors[i].key).addClass("error");
        }
    };

    function clearValidationErrors(context) {
        context.find("span[data-valmsg-for]").removeClass("show").text("");
        context.find(".error").removeClass("error");
    }

}) (jQuery);